
import { TenantAbout, UpdateTenantAbout } from "../../Models/TenantAbout";
import api from "../axios";

export const tenantAboutService = {
  get: async (): Promise<TenantAbout> => {
    const response = await api.get('/tenant-about');
    return response.data;
  },

  update: async (data: UpdateTenantAbout): Promise<boolean> => {
    const response = await api.put('/tenant-about', data);
    return response.data;
  }
};
